// extracted by mini-css-extract-plugin
export var cardContainer = "_p2-0";
export var cardHeader = "_p2-2";
export var collapsedState = "_p2-3";
export var dragHandle = "_p2-5";
export var dragHandleIcon = "_p2-6";
export var dragging = "_p2-1";
export var titleArea = "_p2-4";